<template>
    <div class="excel-page">
        <div class="detail-header flex_between">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="订单计划表" name="1"></el-tab-pane>
              <el-tab-pane label="收入利润表" name="2"></el-tab-pane>
              <el-tab-pane label="货款付款计划表" name="3"></el-tab-pane>
              <el-tab-pane label="费用支付计划表" name="4"></el-tab-pane>
              <el-tab-pane label="资金计划表" name="5"></el-tab-pane>
              <el-tab-pane label="现金流量表" name="6"></el-tab-pane>
            </el-tabs>
            <div class="btn-list flex">
                <el-button size="small" type="primary"  @click="jlSubmit" v-show="activeName!='3'">提交</el-button>
                <el-button size="small" type="warning" @click="handleRefresh" >刷新</el-button>
                
                 
            </div>
        </div>
        <div class="table-box" v-loading="$store.state.excelLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.6)">
            <order-table @getEditData="getEditData" :key="refresh" :data="data.orderPlanTable" :sdate="data.startDate" :edate="data.endDate" :carType="data.carModelNameAndIdList" v-if="activeName==1"></order-table>
            <profit @getEditData="getEditData" :data="data.incomeStatement" :key="refresh" :sdate="data.startDate" :edate="data.endDate" :carType="data.carModelNameAndIdList" v-if="activeName==2"></profit>
            <goods-payment   :key="refresh" :data="data.paymentScheduleForGoodsEntity" :sdate="data.startDate" :edate="data.endDate" :carType="data.carModelNameAndIdList"  v-if="activeName==3"></goods-payment>
            <cost @getEditData="getEditData" :data="data.expensePaymentSchedule" :key="refresh" :sdate="data.startDate" :edate="data.endDate" :carType="data.carModelNameAndIdList"  v-if="activeName==4"></cost>
            <fund @getEditData="getEditData" :data="data.capitalPlanEntity" :key="refresh" :sdate="data.startDate" :edate="data.endDate"   v-if="activeName==5"></fund>
            <cash-flow @getEditData="getEditData" :data="data.cashFlowEntity" :sdate="data.startDate" :edate="data.endDate"  :key="refresh+activeName" v-if="activeName==6"></cash-flow>
            
        </div>
        <el-dialog
          title=""
          :visible.sync="dialogNone"
          width="30%"
          @close="toSet"
          >
          <div slot="title">
            <p >请先录入 <span style="color:#409EFF;font-weight:bold;">基础配置</span></p>
          </div>
          
          <span>录入该区域的基础配署后即可新增批次订单!</span>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="toSet">前往配置</el-button>
          </span>
        </el-dialog>
    </div>
</template>
<script>
// 1.订单计划表 合计部分 先写到 销售利润率
import orderTable from './orderTable.vue'
import cashFlow from './cashFlow.vue'
import profit from './profit.vue'
import goodsPayment from './goodsPayment.vue'
import cost from './cost.vue'
import fund from './fund.vue'

import { getExcel,getEditParam } from '@/api/zd'
export default {
    components:{
        orderTable,cashFlow,profit,goodsPayment,cost,fund
    },
    data(){
        return{
          dialogNone:false,
          date:[],
          editList:[],
          editData:{},
          refresh:1,
          loading:true,
          activeName:'0',
          data:{},
          // loading:false,
          // activeName:'1',
          // data: {}
        
    
  
        
        }
    },
    created(){
      this.refresh = new Date().getTime()
    },
    mounted(){
      this.firstGetData()
      // this.getExcelDate()
    },
    methods:{
        toSet(){
          this.$router.push('/terminal/basic')
        },
        // 计算年月
        getExcelDate(){
          
            let sy= Number(this.data.startDate.split("-")[0]);
            let ey= Number(this.data.endDate.split("-")[0]);

            let sm = Number(this.data.startDate.split("-")[1]);
            let em = Number(this.data.endDate.split("-")[1]);

            let y ;
            let date = []
            if(sy==ey){//同一年
                if(em>sm){
                    for(let i=sm;i<=em;i++){
                        date.push(`${sy}年${i}月`)
                    }
                }else if(em==sm){
                    date.push(`${ey}年${em}月`)
                }else{
                  this.$DonMessage.warning("结束日期必须在开始日期之后")
                }
            }else if(ey>sy){//不同年
                y = ey-sy
                if(y==1){// 没有间隔的一整年
                    for(let i=sm;i<=12;i++){
                        date.push(`${sy}年${i}月`)
                    }
                    for(let j=1;j<=em;j++){
                        date.push(`${ey}年${j}月`)
                    }
                }
                if(y>1){//中间有完整一整年
                    let fwy = sy+1
                    let lwy = ey-1
                    for(let i=sm;i<=12;i++){
                        date.push(`${sy}年${i}月`)
                    }
                    for(let year=fwy;year<=lwy;year++){
                        for(let month=1;month<=12;month++){
                            date.push(`${year}年${month}月`)
                        } 
                    }
                    for(let j=1;j<=em;j++){
                        date.push(`${ey}年${j}月`)
                    }
                }

            }else{
              this.$DonMessage.warning("结束日期必须在开始日期之后")
            }
           
            this.date = date
           
        },
        getEditData(data){
          this.editList = data
       
        },
        getSingleDate(str){
            let date = ''
            let arr = str.substr(0,str.length-1).replace(/[\u4e00-\u9fa5]/g, "-").split("-")
            if(arr[1].length==1){
                arr[1] = '0'+arr[1]
            }
            date = arr[0]+'-'+arr[1]+'-01'
            return date
        },
        handleRefresh(){
          // this.loading = true
          this.$store.state.excelLoading = true
          this.firstGetData()
        },
        async firstGetData(){
          this.$store.state.excelLoading = true
          let query = {
            data:{}
          }
          const res = await getEditParam(query)
          if(res.status==0){
            
            let obj = res.data
            let submitObj = {}
            //订单计划表
            if(obj.orderPlanCustomParams.length>0){
              submitObj.orderPlanCustomParamEntityList = []
              obj.orderPlanCustomParams.map(item=>{
                submitObj.orderPlanCustomParamEntityList.push({
                  "carModelId": item.dataManageCarModelId,
                  "paramValue": item.paramValue,
                  "paramType":item.paramType,
                })
              })
            }
            // 收入利润表
            if(obj.incomeStatementCustomParams.length>0){
              submitObj.incomeStatementCustomParamEntityList = []
              obj.incomeStatementCustomParams.map(item=>{
                submitObj.incomeStatementCustomParamEntityList.push({
                  "carModelId": item.dataManageCarModelId,
                  "paramValue": item.paramValue,
                  "paramType":item.paramType,
                  "paramDate": item.paramDate,
                })
              })
            }
            // 费用支付计划表
            if(obj.expensePaymentScheduleCustomParams.length>0){
              submitObj.expensePaymentScheduleCustomParamList = []
              obj.expensePaymentScheduleCustomParams.map(item=>{
                submitObj.expensePaymentScheduleCustomParamList.push({
                   "carModelId": item.dataManageCarModelId,
                  "paramValue": item.paramValue,
                  "paramType":item.paramType,
                  "paramDate": item.paramDate,
                })
              })
            }
            // 资金计划表
            if(obj.capitalPlanCustomParams.length>0){
              submitObj.capitalPlanCustomParamList = []
              obj.capitalPlanCustomParams.map(item=>{
                submitObj.capitalPlanCustomParamList.push({
                  "dataManagePaymentMethodId": item.dataManagePaymentMethodId,
                  "paymentMethod":item.paymentMethod,
                  "paramValue": item.paramValue,
                  "accountName":item.accountName,
                  "paramDate": item.paramDate,
                })
              })
            }
            // 现金流量表
            if(obj.cashFlowCustomParams.length>0){
              submitObj.cashFlowCustomParamList = []
              obj.cashFlowCustomParams.map(item=>{
                submitObj.cashFlowCustomParamList.push({
                 "accountName": item.accountName,
                  "paramValue": item.paramValue,
                  "paramType":item.paramType,
                  "paramDate": item.paramDate,
                })
              })
            }
            
            this.initData(submitObj)
          }else if(res.status=='A0001'){
              this.dialogNone = true
            }
        },
        async initData(obj){
            let query = {data: {},}
            query.data=obj
            const res = await getExcel(query)
            if(res.status==0){
              this.loading = false
              this.$store.state.excelLoading = false
              if(res.data.carModelNameAndIdList.length==0){
                this.dialogNone = true
                
                
              }else{
                this.data = res.data
                this.getExcelDate()
                let active =sessionStorage.getItem('active')
                if(active!==null&&active!==''){
                  this.activeName = `${active}`
                }else{

                  this.activeName='1'
                  sessionStorage.setItem('active',this.activeName)
                }
              }
              
              

            }else if(res.status=='A0001'){
              this.dialogNone = true
            }else{
              this.$DonMessage.error(res.message)
            }
        },
        async submitData(arr,obj){
          this.loading = true
          this.$store.state.excelLoading = true
          let array = []
            let query = {"data": {},}
            if(this.activeName==1){
              arr.map(item=>{
                array.push({
                  "carModelId": item.id,
                  "paramValue": item.v.v,
                  "paramType":item.paramType,
                })
              })
              query.data.orderPlanCustomParamEntityList = [...array]
            }
            if(this.activeName==2){
              arr.map(item=>{
               
                array.push({
                  "carModelId": item.id,
                  "paramValue": item.v.v,
                  "paramType":item.type,
                  "paramDate": item.date,
                })

              })
              query.data.incomeStatementCustomParamEntityList = [...array]
            }
            if(this.activeName==4){
              arr.map(item=>{
             
                array.push({
                  "carModelId": item.id,
                  "paramValue": item.v.v,
                  "paramType":item.type,
                  "paramDate": item.date,
                })

              })
              query.data.expensePaymentScheduleCustomParamList = [...array]
            }
            if(this.activeName==5){
              arr.map(item=>{
                
                array.push({
                  "dataManagePaymentMethodId": item.id,
                  "paymentMethod":item.paymentMethod,
                  "paramValue": item.v.v,
                  "accountName":item.accountName,
                  "paramDate": item.date,
                })

              })
              query.data.capitalPlanCustomParamList = [...array]
            }
            if(this.activeName==6){
              arr.map(item=>{
           
                array.push({

                  "accountName": item.accountName,
                  "paramValue": item.v.v,
                  "paramType":item.type,
                  "paramDate": item.date,
                })

              })
              query.data.cashFlowCustomParamList = [...array]
            }
            
            Object.keys(obj).forEach(function(key) {
             
              if(obj[key].length==0){
                delete obj[key]
              }
            });
          
            query.data = {...query.data,...obj}
            
            // return
            const res = await getExcel(query)
            
            if(res.status==0){
              // this.refresh
              this.refresh= new Date().getTime()
              // window.luckysheet.exitEditMode();
              window.luckysheet.destroy();
              this.activeName = '0'
              this.loading = false
              this.$store.state.excelLoading = false
              this.data = res.data
              this.getExcelDate()
              let active =sessionStorage.getItem('active')
              if(active!==null&&active!==''){
                this.activeName = `${active}`
              }else{

                this.activeName='1'
                sessionStorage.setItem('active',this.activeName)
              }
              

            }
        },
        getOtherDataSubmit(){
        
          let obj = {
            orderPlanCustomParamEntityList:[],
            incomeStatementCustomParamEntityList:[],
            expensePaymentScheduleCustomParamList:[],
            capitalPlanCustomParamList:[],
            cashFlowCustomParamList:[]
          }
          this.data.orderPlanTable.orderPlanTableEachCarModelList.map(item=>{//订单计划表
             obj.orderPlanCustomParamEntityList.push(
              {
                "carModelId": item.carModelId,
                "paramValue":item.openingBalance,
                "paramType":3
              },
              {
                "carModelId": item.carModelId,
                "paramValue":item.openingBalanceOrderPlan,
                "paramType":1
              },
              {
                "carModelId": item.carModelId,
                "paramValue":item.openingBalanceSalesPlan,
                "paramType":2
              },
            )
          })
          let incomeArr = []
          // 收入利润表 
          this.data.incomeStatement.incomeStatementEachCarModel.map(item=>{
            item.monthlySalesPriceChange.map((data,i)=>{ //单价变动
              if(data!=0&&data!=''){
                incomeArr.push(
                  {
                    carModelId:item.carModelId,
                    paramValue:data,
                    paramType:1,
                    paramDate: '',
                    i:i
                  }
                )
              }
            })
            item.monthlyCostDataChange.map((data,i)=>{ //成本变动
              if(data!=0&&data!=''){
                incomeArr.push(
                  {
                    carModelId:item.carModelId,
                    paramValue:data,
                    paramType:2,
                    paramDate: '',
                    i:i
                  }
                )
              }
            })
          })
          this.data.incomeStatement.incomeStatementEachMonth.map(data=>{//合计
              if(data.operatingExpensesAndOther!=0&&data.operatingExpensesAndOther!=''){
                incomeArr.push(
                  {
                    carModelId:0,
                    paramValue:data.operatingExpensesAndOther,
                    paramType:3,
                    paramDate: data.month,
                  },
                   
                )
              }
          })
          let payArr = []
          // 费用支付计划表  
          this.data.expensePaymentSchedule.expensePaymentScheduleEachMonth.map(item=>{//合计
            if(item.adjustment!=0&&item.adjustment!=''){
               payArr.push(
                {
                  "carModelId": 0,
                  "paramValue": item.adjustment,
                  "paramType":1,
                  "paramDate": item.month,
                },)
            }
            if(item.adjustmentDescription!=0&&item.adjustmentDescription!=''){
              payArr.push(
                {
                  "carModelId": 0,
                  "paramValue": item.adjustmentDescription,
                  "paramType":2,
                  "paramDate": item.month,
                }
              )
            }
              
          })
          this.data.expensePaymentSchedule.expensePaymentScheduleEachCarModel.map(item=>{//单个车型
            item.otherCharges.map((data,i)=>{
              if(data!=0&&data!=''){
                payArr.push(
                  {
                    "carModelId": item.carModelId,
                    "paramValue": data,
                    "paramType":3,
                    "paramDate": '',
                    i:i
                  }
                )
              }
            })
            
              

          })
         
          // 资金计划表 1自有资金,2后台维护大区其余付款方式
          let obj1 = this.data.capitalPlanEntity.capitalPlanOwnCapital//自有资金
          // 期初数
          let qcs = []
          let dysf = []
          qcs.push(
            {
               "dataManagePaymentMethodId": obj1.paymentMethodId,
                "paymentMethod":1,
                "paramValue": obj1.ownCapitalBalanceOpeningBalance,
                "accountName":2,
                "paramDate": '',
            },
            {
               "dataManagePaymentMethodId": obj1.paymentMethodId,
                "paymentMethod":1,
                "paramValue": obj1.currentMonthActualPayableOpeningBalance,
                "accountName":1,
                "paramDate": '',
            },
          )
          
          // 当月实付-货款
          obj1.currentMonthActualPaidGoods.map((item,i)=>{
            if(item!=0&&item!=''){
              dysf.push(
                {
                  "dataManagePaymentMethodId": obj1.paymentMethodId,
                  "paymentMethod":1,
                  "paramValue": item,
                  "accountName":4,
                  "paramDate": '',
                  i:i
                }
              )
            }

          })
         
          // 其他付款方式
          this.data.capitalPlanEntity.capitalPlanOtherMethodList.map(item=>{
            // 当月实付
            item.currentMonthActualPaid.map((data,i)=>{
              if(data!=0&&data!=''){
                dysf.push({
                  "dataManagePaymentMethodId": item.paymentMethodId,
                  "paymentMethod":2,
                  "paramValue": data,
                  "accountName":5,
                  "paramDate": '',
                  i:i
                })
              }
              
            })
            // 期初数
            qcs.push(
               {
               "dataManagePaymentMethodId": item.paymentMethodId,
                "paymentMethod":2,
                "paramValue": item.capitalBalanceOpeningBalance,
                "accountName":3,
                "paramDate": '',
              },
              {
               "dataManagePaymentMethodId": item.paymentMethodId,
                "paymentMethod":2,
                "paramValue": item.currentMonthActualPayableOpeningBalance,
                "accountName":1,
                "paramDate": '',
              },
            )
          })
          let capitalArr = [...qcs,...dysf]

          // 现金流量表 
          let cashArr = []
          let obj2 = this.data.cashFlowEntity.cashFlowActual//实际
          obj2.otherAdjustmentOne.map((item,i)=>{
             if(item!=0&&item!=''){
                cashArr.push(
              {
                "accountName": 1,
                "paramValue": item,
                "paramType":2,
                "paramDate": '',
                i:i
              }
            )
             }

          })
          obj2.otherAdjustmentTwo.map((item,i)=>{
            if(item!=0&&item!=''){
               cashArr.push(
                {
                  "accountName": 2,
                  "paramValue": item,
                  "paramType":2,
                  "paramDate": '',
                  i:i
                }
              )
            } 
           
          })
          obj2.cashInflowAdjustmentDescription.map((item,i)=>{
            if(item!=0&&item!=''){
              cashArr.push(
              {
                "accountName": 3,
                "paramValue": item,
                "paramType":2,
                "paramDate": '',
                i:i
              }
              )
            }

          })
          obj2.cashOutflowAdjustmentDescription.map((item,i)=>{
            if(item!=0&&item!=''){
               cashArr.push(
              {
                "accountName": 4,
                "paramValue": item,
                "paramType":2,
                "paramDate": '',
                i:i
              }
            )
            }

          })
          if(this.date.length>0){
            this.date.map((item1,i)=>{
              // 收入利润表
              if(incomeArr.length>0){
                incomeArr.forEach(item2=>{
                  if(item2.paramDate==''&&i==item2.i){
                    item2.paramDate = this.getSingleDate(item1)
                  }
                })
              }
              // 费用支付计划表
              if(payArr.length>0){
                payArr.forEach(item2=>{
                  if(item2.paramDate==''&&i==item2.i){
                    item2.paramDate = this.getSingleDate(item1)
                  }
                })
              }
              // 现金流量表
              if(cashArr.length>0){
                cashArr.forEach(item2=>{
                  if(item2.paramDate==''&&i==item2.i){
                    item2.paramDate = this.getSingleDate(item1)
                  }
                })
              }
              // 费用支付计划表
              if(capitalArr.length>0){
                capitalArr.forEach(item2=>{
                  if(item2.paramDate==''&&item2.i!==null&&item2.i!==undefined&&i==item2.i){
                    item2.paramDate = this.getSingleDate(item1)
                  }
                })
              }
            })
          }
          obj.incomeStatementCustomParamEntityList = incomeArr
          obj.expensePaymentScheduleCustomParamList = payArr
          obj.cashFlowCustomParamList = cashArr
          if(capitalArr.length>0){
            capitalArr.map(item=>{
              obj.capitalPlanCustomParamList.push({
                "dataManagePaymentMethodId":item.dataManagePaymentMethodId,
                "accountName": item.accountName,
                "paramValue": item.paramValue,
                "paymentMethod":item.paymentMethod,
                "paramDate": item.paramDate,
              })
            })
          }else{
             obj.capitalPlanCustomParamList = capitalArr
          }
          if(this.activeName==1){
            delete obj.orderPlanCustomParamEntityList
            this.submitOrderTable(obj)
          }
          if(this.activeName==2){
            delete obj.incomeStatementCustomParamEntityList
            this.submitprofitTable(obj)
          }
          if(this.activeName==4){
            delete obj.expensePaymentScheduleCustomParamList
            this.submitcostTable(obj)
          }
          if(this.activeName==5){
            delete obj.capitalPlanCustomParamList
            
            this.submitFundTable(obj)
          }
          if(this.activeName==6){
            delete obj.cashFlowCustomParamList
    
            this.submitCashTable(obj)
          }
        },
        submitOrderTable(otherObj){
          // 终端库存、订单计划、销售计划不是0和空都能传
          let arr = window.luckysheet.getAllSheets()[0].celldata
          const rowArr = arr.filter(item => item.v.v=='终端库存'&&item.r>10);
          const qcs = arr.filter(item => item.v.v=='期初数');
          const orderPlan = arr.filter(item => item.v.v=='订单计划'&&item.r>10);
          const salePlan = arr.filter(item => item.v.v=='销售计划'&&item.r>10);
          const canEditRow = [...rowArr,...orderPlan,...salePlan]
        
          let enterList = []
          arr.map(item1=>{
            canEditRow.map(item2=>{
              if(item1.r==item2.r&&item1.c==qcs[0].c){
                enterList.push({...item1,name:item2.v.v})
              }
            })
          })
    
          if(enterList.length==0){
            this.$DonMessage.warning('请填写车型的终端库存、订单计划、销售计划的期初数后再提交')
            return
          }
          enterList.forEach(data=>{
            if(!data.v.v){
              data.v.v = 0
            }
            if(data.name=='订单计划'){
              data.paramType=1,
              data.carName=window.luckysheet.getCellValue(data.r,0)
            }
            if(data.name=='销售计划'){
              data.paramType=2,
              data.carName=window.luckysheet.getCellValue((data.r-5),0)
            }
            if(data.name=='终端库存'){
              data.paramType=3,
              data.carName=window.luckysheet.getCellValue((data.r-6),0)
            }
          })
          
          this.data.carModelNameAndIdList.map(item1=>{
           
              enterList.forEach(item2=>{
                if(item1.carModelName == item2.carName){
                  item2.id=item1.carModelId
                }
              })
          })
   
          this.submitData(enterList,otherObj)
        },
        submitprofitTable(otherObj){
          let arr = window.luckysheet.getAllSheets()[0].celldata
          const rowArr = arr.filter(item => item.v.v=='运营费及其他');
          const qcs = arr.filter(item => item.v.v=='合计');
          const orderPlan = arr.filter(item => item.v.v=='当月销售单价变动（usd/台）');
          const salePlan = arr.filter(item => item.v.v=='当月成本数据变动（usd/台）');
          const canEditRow = [...rowArr,...orderPlan,...salePlan]
          
          let enterList = []
          arr.map(item1=>{
            canEditRow.map(item2=>{
              if(item1.r==item2.r&&item1.c>=(qcs[0].c+1)&&item1.c<=(5+this.date.length)&&item1.v.v!=0&&item1.v.v!=''){
                enterList.push({...item1,name:item2.v.v,date:window.luckysheet.getCellValue(0,item1.c)})
              }
            })
          })
          if(enterList.length==0){
            this.$DonMessage.warning('请填写合计项的运营费及其他、车型项的当月销售单价变动、当月成本数据变动后再提交')
            return
          }
  
          enterList.forEach(data=>{
            data.date = this.getSingleDate(data.date)
            if(data.name=='运营费及其他'){
              data.type=3,
              data.id = 0
            }
            if(data.name=='当月销售单价变动（usd/台）'){
              data.type=1,
              data.carName=window.luckysheet.getCellValue((data.r-8),0)
            }
            if(data.name=='当月成本数据变动（usd/台）'){
              data.type=2,
              data.carName=window.luckysheet.getCellValue((data.r-9),0)
            }
          })
          this.data.carModelNameAndIdList.map(item=>{
            enterList.forEach(item1=>{
              if(item1.carName&&item1.carName==item.carModelName){
                item1.id=item.carModelId
              }
            })
            
          })

          this.submitData(enterList,otherObj)
        },
        submitcostTable(otherObj){
          
          const arr = window.luckysheet.getAllSheets()[0].celldata
          const rowArr = arr.filter(item => item.v.v=='调整项');
          const qcs = arr.filter(item => item.v.v=='合计');
          const orderPlan = arr.filter(item => item.v.v=='调整说明');
          const salePlan = arr.filter(item => item.v.v=='其他费用'&&item.r>7);
          const canEditRow = [...rowArr,...orderPlan,...salePlan]
          let enterList = []
          arr.map(item1=>{
            canEditRow.map(item2=>{
              if(item1.r==item2.r&&item1.c>=(qcs[0].c+1)&&item1.c<=(4+this.date.length)&&item1.v.v!=0&&item1.v.v!=''){
                enterList.push({...item1,name:item2.v.v,date:window.luckysheet.getCellValue(0,item1.c)})
              }
            })
          })
          if(enterList.length==0){
            this.$DonMessage.warning('请填写合计部分的调整项、调整说明或车型部分的其他费用后再提交')
            return
          }
          
          enterList.forEach(data=>{
            data.date = this.getSingleDate(data.date)
            if(data.name=='调整项'){
              data.type=1
              data.id = 0
            }
            if(data.name=='调整说明'){
              data.id = 0
              data.type=2
             
            }
            if(data.name=='其他费用'){
              data.type=3
              data.carName=window.luckysheet.getCellValue((data.r-2),0)
            }
          })
          this.data.carModelNameAndIdList.map(item=>{
            enterList.forEach(item1=>{
              if(item1.carName&&item1.carName==item.carModelName){
                item1.id=item.carModelId
              }
            })
            
          })
          
          this.submitData(enterList,otherObj)
        },
        submitFundTable(otherObj){
          
          let arr = window.luckysheet.getAllSheets()[0].celldata
          const qcs = arr.filter(item=>item.v.v=='期初数')
          const kmmc = arr.filter(item=>item.v.v=='科目名称')
          const shouldPay = arr.filter(item=>item.v.v=='当月实际应支付'&&item.r>10)
          let otherBalance = []//其他余额
          arr.map(item=>{
            this.data.capitalPlanEntity.capitalPlanOtherMethodList.map((m,j)=>{
              if(item.c==kmmc[0].c&&item.r==(13+(j*5))){
                otherBalance.push(item)
              }
            })
          })
          const canEditRow = [...shouldPay,...otherBalance]
          let qcsList = []
          qcsList.push(
            {
              c:4,
              r:5,
              v:{v:window.luckysheet.getCellValue(5,4),},
              name:'当月实际应支付'
            },
            {
              c:4,
              r:8,
              v:{v:window.luckysheet.getCellValue(8,4),},
              name:'自有资金余额'
            },
            )
          arr.map(item1=>{
            canEditRow.map(item2=>{
              if(item1.r===item2.r&&item1.c===qcs[0].c){
                qcsList.push({...item1,name:item2.v.v,})
              }
              
            })
          })
          qcsList.forEach(item=>{
            item.date = ''
            if(!item.v.v){
              item.v.v = 0
            }
            if(item.name=='自有资金余额'){
              item.accountName=2
              item.paymentMethod=1
              item.payName = window.luckysheet.getCellValue(item.r-7,1)
            }else if(item.name=='当月实际应支付'){
              item.accountName=1
              if(item.r>10){
                item.paymentMethod=2
                item.payName = window.luckysheet.getCellValue((item.r-2),1)
              }else{
                item.paymentMethod=1
                item.payName = window.luckysheet.getCellValue((item.r-4),1)
              }
            }else{
              item.payName = window.luckysheet.getCellValue((item.r-4),1)
              item.accountName=3
              item.paymentMethod=2
            }
          })
          const payGoods = arr.filter(item=>item.v.v=='当月实付-货款')
          const pay = arr.filter(item=>item.v.v=='当月实付')
          const hj = arr.filter(item => item.v.v=='合计');
          let canEditCol = [...payGoods,...pay]
          let enterList = []
          canEditCol.map(item1=>{
            arr.map(item2=>{
              if(item2.r==item1.r&&item2.c>=(hj[0].c+1)&&item2.v.v!==0&&item2.v.v&&item1.c<=(5+this.date.length)){
                enterList.push({...item2,name:item1.v.v,date:window.luckysheet.getCellValue(0,item2.c)})
              }
            })
          })

          enterList.forEach(item=>{
            item.date = this.getSingleDate(item.date)
            
            if(item.name=='当月实付-货款'){
              item.accountName=4
              item.paymentMethod=1
              item.payName = window.luckysheet.getCellValue(item.r-5,1)
            }
            if(item.name == '当月实付'){
              item.accountName=5
              item.paymentMethod=2
              item.payName = window.luckysheet.getCellValue(item.r-3,1)
            }
            
          })
          
          let array = [...qcsList,...enterList]
          if(array.length==0){
            this.$DonMessage.warning('请填写当月实际应支付、资金余额的期初数，当月实付-货款，当月实付后再提交')
            return
          }
          this.data.capitalPlanEntity.capitalPlanOtherMethodList.map(item1=>{
            array.forEach(item2=>{
              if(item1.paymentMethod==item2.payName){
                item2.id = item1.paymentMethodId
              }
              if(item2.date!==''){
                item2.date = this.getSingleDate(item2.date)
              }
            })
          })
          let obj = this.data.capitalPlanEntity.capitalPlanOwnCapital
        
          array.forEach(item=>{
            if(item.payName==obj.paymentMethod){
                item.id = obj.paymentMethodId
              }
          })
          
          
    
          this.submitData(array,otherObj)
          
        },
        submitCashTable(otherObj){
          const arr = window.luckysheet.getAllSheets()[0].celldata
          const rowArr = arr.filter(item => item.v.v=='其他调整项');
          const qcs = arr.filter(item => item.v.v=='合计');
          const orderPlan = arr.filter(item => item.v.v=='现金流出调整说明');
          const salePlan = arr.filter(item => item.v.v=='现金流入调整说明');
          const canEditRow = [...rowArr,...orderPlan,...salePlan]
          let enterList = []
          arr.map(item1=>{
            canEditRow.map(item2=>{
              if(item1.r==item2.r&&item1.c>=(qcs[0].c+1)&&item1.c<=(5+this.date.length)&&item1.v.v!=0&&item1.v.v!=''){
                enterList.push({...item1,name:item2.v.v,date:window.luckysheet.getCellValue(0,item1.c)})
              }
            })
          })
          if(enterList.length==0){
            this.$message.warning('请填写合计部分的调整项、调整说明或车型部分的其他费用后再提交')
            return
          }
         
          enterList.forEach(data=>{
            data.date = this.getSingleDate(data.date)
            if(data.name=='其他调整项'){
              data.type=2
              if(data.r>13){
                data.accountName = 2
              }else{
                data.accountName = 1
              }
              
            }
            if(data.name=='现金流出调整说明'){
              
              data.type=2
              data.accountName = 4
             
            }
            if(data.name=='现金流入调整说明'){
              data.type=2
              data.accountName = 3
             
            }
          })
         
          this.submitData(enterList,otherObj)
         
        },
        jlSubmit(){
          window.luckysheet.exitEditMode();
          this.$confirm('新提交的数据将会在后台数据库进行核算，请提交后刷新再进行查阅报表。', '提交修改的数据？', {
            confirmButtonText: '确认',
            cancelButtonText: '返回修改',
           
          }).then(() => {
           this.getOtherDataSubmit()
         
          }).catch(() => {
                 
          });
        },
        
        handleClick(){
          // this.loading = true
          this.$store.state.excelLoading = true
          this.editList = []
          window.luckysheet.exitEditMode();
          window.luckysheet.destroy();
          sessionStorage.setItem('active',this.activeName)
          this.refresh= new Date().getTime()
          
        }
    }
}
</script>
<style lang="scss" scoped>
.excel-page{
    width: 100%;
    box-sizing: border-box;
    padding-left: 10px;
    position: relative;
    overflow: hidden;
    min-height: calc(100vh - 154px);
    ::v-deep .el-tabs__header{
        // width: 100px!important;
    }
    .detail-header{
        width: 90%;
        padding: 10px;
        box-sizing: border-box;
        position: absolute;
        top: 0;
        left: 0;
        height: 60px;
        background:#fff;
        z-index: 999;
    }
    .table-box{
        width: 100%;
        overflow: hidden;
        min-height: calc(100vh - 158px);
        // max-height: 100vh;
        // background: #eee;
    }
 
}
</style>